<template>
  <div class="tracking">
    <page-header
      title="Trackings"
      breadcrumb="Dashboard  > Bookings & Shipments  > Trackings"
    />
    <tracking-data-table />
  </div>
</template>

<script>
import TrackingDataTable from "./TrackingDataTable";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    TrackingDataTable,
    PageHeader
  },
};
</script>

<style></style>
